// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-mfe-id=\"npl-body.patsnap\"]{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-negative:0;flex-shrink:0}[data-mfe-id=\"npl-body.patsnap\"] .left-refine-result-wrap,[data-mfe-id=\"npl-body.patsnap\"] .mainform{max-height:calc(100vh - 64px);overflow-y:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
